import { render, staticRenderFns } from "./pm-app.vue?vue&type=template&id=537aa87c&"
import script from "./pm-app.vue?vue&type=script&lang=js&"
export * from "./pm-app.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports